<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索条件：
                        <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-input>
                    </div>

                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <!--
                    <div style="">
                        <el-radio-group v-model="searchVal.type" @change="searchDo">
                            <el-radio-button label="YSF">支付码</el-radio-button>
                            <el-radio-button label="SXF">刷脸</el-radio-button>
                            <el-radio-button label="KDB">聚合</el-radio-button>
                        </el-radio-group>
                    </div>
                -->

                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV"> <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true" /> </el-button>
                </div>
            </div>
            <div v-show="showFV" >
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>统计日期： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM-dd" style="width:250px;margin-right: 15px;" type="daterange" size="mini" unlink-panels start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" /></div>
                </div>
            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="jnl"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="salesmanName" label="客户经理" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="agentName" label="服务商" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cnt" label="交易笔数" width="120" align="center"  sortable >
                </el-table-column>
                <el-table-column prop="amount" label="交易额" align="right"  sortable >
                </el-table-column>
                <el-table-column prop="agentEarning" label="客户经理收益" align="right" sortable width="130">
                </el-table-column>
                <el-table-column prop="agentParentEarning" label="服务商收益" align="right" sortable width="130">
                </el-table-column>
                <el-table-column
                        align="center"
                        width="90"
                        label="结算费率%">
                    <template slot-scope="scope">
                        <el-tag type="success" color="#FFFFFF">{{scope.row.mchAgentRate}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                        align="center"
                        width="90"
                        label="成本费率%">
                    <template slot-scope="scope">
                        <el-tag type="primary" color="#FFFFFF">{{scope.row.mchAgentParentRate}}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">明细</el-button>
                    </template>
                </el-table-column>


                <!--
                <el-table-column prop="rewardAmt" label="佣金分润" width="200" align="right" :formatter="funFmtTransAmt3" sortable />
                -->
            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="height:32px;line-height: 32px; font-family: 'Arial Black'; font-size: 15px; background-color:green; color: white; padding-left: 15px;padding-right: 15px; ">{{msgInfo}}</div>
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <div class="yx-flex-h-end">
                <el-pagination
                        :current-page.sync="page"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev,pager,next, jumper,->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>


        <el-drawer
                :visible.sync="drawer"
                :show-close=false
                size = "60%"
                :with-header="false"
                direction="rtl">
            <div style="padding: 10px 10px 30px 10px">
                <span class="tipTitle-collapse">
                    收益合计
                    <span style="font-size:12px; font-weight: normal"> - <el-tag type="success" color="#FFFFFF">{{totalInfo.salesmanName}}</el-tag> - <el-tag type="success" color="#FFFFFF">{{totalInfo.mchAgentRate}}%</el-tag></span>
                    </span>

                <el-table :data="[totalInfo]" v-if="mchs" >
                    <el-table-column label="商户数" align="center">
                        {{mchs.length}}
                    </el-table-column>
                    <el-table-column prop="amount" label="交易额" align="center" />
                    <el-table-column prop="cnt" label="交易笔数" align="center"/>
                    <el-table-column prop="agentEarning" label="客户经理收益" align="center">
                    </el-table-column>
                    <el-table-column  prop="agentParentEarning" label="服务商收益" align="center">
                    </el-table-column>
                </el-table>
                <div style="height: 30px;"></div>
                <span class="tipTitle-collapse">
                    <span style="">商户汇总</span>
                </span>
                <div style="margin-top: 10px;">
                    <el-table :data="mchs" v-loading="loading2" size="mini" border stripe >
                        <el-table-column type="index" label="序号" align="center" />
                        <el-table-column prop="mchName" label="商户名称"  show-overflow-tooltip width="120" />
                        <el-table-column align="center" width="85" label="商户费率%">
                            <template slot-scope="scope">
                                <el-tag type="primary" color="#FFFFFF">{{scope.row.mchRate}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cnt" label="交易笔数" align="center" width="100" sortable />
                        <el-table-column prop="amount" label="交易额" align="right" sortable />
                        <el-table-column prop="agentEarning" label="客户经理收益" align="right" sortable  width="130">
                        </el-table-column>
                        <el-table-column prop="agentParentEarning" label="服务商收益" align="right" sortable width="130">
                        </el-table-column>
                    </el-table>
                    <!-- 分页栏 -->
                    <div class="yx-flex-h-end">
                        <el-pagination small
                                       :page-size="size2"
                                       @current-change="currentChangeFA"
                                       @size-change="sizeChangeFA"
                                       layout="total, prev, pager, next"
                                       :total="total2">
                        </el-pagination>
                    </div>
                </div>
            </div>

        </el-drawer>

    </div>

</template>

<script>
    export default {
        name: "RptSalTraTot", //客户经理交易汇总
        data() {
            return {
                loading2: false,
                loading: false,
                showFV: false,
                total: 0,
                msgInfo: 0,
                page: 1,
                size: 10,
                total2: 0,
                page2: 1,
                size2: 10,
                jnl: [],
                mchs: null,
                keywordList: [
//                    {id:"devInfo.terSn",name:"设备序列号"},
//                    {id:"devInfo.inAgentName",name:"服务商名称"},
                ],
                searchVal: {
                    type: 'YSF',
                    keywordMethod: '',
                    keyword: '',
                    payWayCode : null,
                    payModeCode : null,
                    transDateScope : null
                },
                totalInfo:{

                },
                drawer: false
            }
        },
        computed: {
            user() {
                return this.$store.state.currentHr;
            }
        },
        mounted() {
            this.initJnl();
        },
        methods: {
            sizeChangeFA(currentSize) {
                this.size2 = currentSize;
                this.initMch();
            },
            currentChangeFA(currentPage) {
                this.page2 = currentPage;
                this.initMch();
            },
            searchReset() {
                this.searchVal = {};
                this.searchVal.totalTypes = [];
            },
            searchDo() {
                this.page = 1;
                this.initJnl();
            },
            viewDetail(row) {
                console.log(row)
                Object.assign(this.totalInfo, row);
                this.drawer = true;
                this.page2 = 1;
                this.size2 = 10;
                this.total2 = 0;
                this.initMch();
            },
            initMch() {
                this.loading2 = true;
                let url = '/rpt/agent/mch/rewardTotalsMchBySalesman?page=' + this.page2 + '&size=' + this.size2 + '&id=' + this.totalInfo.salesmanId;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                /**
                 if (this.searchVal.keywordMethod && this.searchVal.keyword)
                 url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                 if (this.searchVal.transDateScope)
                 url += '&transDateScope=' + this.searchVal.transDateScope;
                 */
                this.mchs = null
                this.getRequest(url).then(resp => {
                    this.loading2 = false;
                    if (resp) {
                        this.mchs = resp.data;
                        this.total2 = resp.total;
                    }
                });
            },
            initJnl() {
                this.loading = true;
                let url = '/rpt/agent/mch/rewardTotalsBySalesman?page=' + this.page + '&size=' + this.size;
                if (this.searchVal.totalTypes)
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.jnl = resp.data;
                        this.total = resp.total;
                        this.msgInfo = resp.msgInfo;
                    }
                });
            },
            exportData() {


                let url = '/rpt/agent/salTransTotals/export?page=1';
                if (this.searchVal.totalTypes)
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;


                window.open(url, '_parent');

            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initJnl();
            }
        }
    }
</script>

<style>

</style>
